<template>
    <div class="columns is-mobile is-vcentered academy-summary-row">
        <div class="column is-1 is-size-6-mobile is-size-5">
            <span> #{{ academyResult.place }} </span>
        </div>
        <div class="column is-size-7-mobile is-size-6 academy-name">
            {{ academyResult.academyName }}

            <AccordionLink
                v-if="hasMergedResults(academyResult.academyId)"
                @click="toggleMergedResults(academyResult.academyId)"
                :is-visible="isVisibleExpandedResult(academyResult.academyId)"
            />
        </div>

        <div v-for="(ruleBreakdown, index) in academyResult.ruleBreakdowns" :key="index">
            <div v-if="ruleBreakdown.type === 'wonMatchesBreakdown'">
                <div class="academy-medal">
                    <div>
                        {{ ruleBreakdown.value.wonMatches }}
                    </div>
                    <div class="has-text-success has-text-weight-bold">
                        {{ translate("page.admin_academy_results.wins") }}
                    </div>
                </div>
            </div>

            <div
                v-if="ruleBreakdown.type === 'awardedMedalsBreakdown'"
                class="is-flex is-flex-wrap-wrap is-align-items-center is-justify-content-center"
            >
                <AcademyStat :count="getCountForPlace(ruleBreakdown, 1)" type="gold" :place="1" />
                <AcademyStat :count="getCountForPlace(ruleBreakdown, 2)" type="silver" :place="2" />
                <AcademyStat :count="getCountForPlace(ruleBreakdown, 3)" type="bronze" :place="3" />

                <template v-if="isExtendedClassification(academyResult)">
                    <div class="is-flex">
                        <AcademyStat :count="getCountForPlace(ruleBreakdown, 4)" :place="4" type="extended" />
                        <AcademyStat :count="getCountForPlace(ruleBreakdown, 5)" :place="5" type="extended" />
                        <AcademyStat :count="getCountForPlace(ruleBreakdown, 6)" :place="6" type="extended" />
                        <AcademyStat :count="getCountForPlace(ruleBreakdown, 7)" :place="7" type="extended" />
                        <AcademyStat :count="getCountForPlace(ruleBreakdown, 8)" :place="8" type="extended" />
                    </div>
                </template>
            </div>
        </div>

        <AcademyStat class="column is-narrow" :count="academyResult.points" type="points" />
    </div>
</template>

<script setup lang="ts">
    import AccordionLink from "../Common/AccordionLink.vue";
    import AcademyStat from "./AcademyStat.vue";
    import { computed } from "vue";
    import { AwardedMedalsBreakdown, SingleAcademyCalculation } from "../Api/competitorResultsApi";
    import { useAcademyResultsStore } from "./academyResultsStore";
    import { translate } from "../Common/translations";

    defineProps<{
        academyResult: SingleAcademyCalculation;
    }>();
    const store2 = useAcademyResultsStore();

    //Expanded results
    const expandedResults = computed(() => store2.expandedResults);

    function toggleMergedResults(academyId: number) {
        //Having array with computed doesn't work.
        store2.toggleMergedResults(academyId);
    }

    function isVisibleExpandedResult(academyId) {
        return !!expandedResults.value[academyId];
    }

    //Affiliated results
    const parentResultsMap = computed(() => store2.parentResultsMap);

    const hasMergedResults = academyId => {
        return !!parentResultsMap.value[academyId];
    };

    //Getting results
    const getCountForPlace = (ruleBreakdown: AwardedMedalsBreakdown, place: number) => {
        return ruleBreakdown.value.medals[place] ?? 0;
    };

    const isExtendedClassification = (academyResult: SingleAcademyCalculation) => {
        return academyResult.ruleBreakdowns.some(ruleBreakdown => {
            if (ruleBreakdown.type === "awardedMedalsBreakdown") {
                return ruleBreakdown.value.useExtendedClassification;
            }
            return false;
        });
    };
</script>

<style scoped></style>
